import React, { useEffect, useState } from 'react';
import SandboxIframe from './injectPlatform/sandboxIframe';
import WebPlatformRenderer from './injectPlatform/webPlatformRenderer';
import ViewportWrapper from './viewportMockWrapper';
import { viewportConfigs } from './viewportMockWrapper/constants';
import { Platform } from './viewportMockWrapper/types';
import { initializePlatformMock } from './viewportMockWrapper/utils';

function MockHostApp() {
  const storedPlatform =
    (localStorage.getItem('mock_platform_type') as Platform) || 'web';
  const { width, height } = viewportConfigs[storedPlatform];

  const [platform, setPlatform] = useState<
    'ios' | 'android' | 'web' | 'selfserve'
  >((storedPlatform as any) ?? 'web');

  const [showDialog, setShowDialog] = useState(true);

  useEffect(() => {
    initializePlatformMock(platform);
  }, [platform]);

  return (
    <ViewportWrapper
      platform={platform}
      setPlatform={setPlatform as any}
      onChangeApp={() => {
        setShowDialog(true);
      }}
    >
      {['ios', 'android'].includes(platform) ? (
        // @ts-ignore
        <SandboxIframe
          platform={platform as any}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      ) : (
        <WebPlatformRenderer
          platform={platform}
          width={width}
          height={height}
        />
      )}
    </ViewportWrapper>
  );
}

export default MockHostApp;
